/** @format */
import { styled } from "@mui/material/styles";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Icons from "../../Assets/Icons";
// import "./index.scss";
export default function AccordionComponent({ title, img1, img2 }) {
  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary expandIcon={<Icons name='add' />} {...props} />
  ))(({ theme }) => ({
    backgroundColor: "#EAEAEA",
    borderRadius: "8px",
    border: "none",
  }));
  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    borderRadius: "8px",
    marginBottom: "16px",
    border: "none",
  }));
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    border: "none",
  }));
  return (
    <Accordion>
      <AccordionSummary aria-controls='panel1a-content' id='panel1a-header'>
        <Typography>
          <h5 className='accordion-title'> {title}</h5>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          <img src={img1} />
          {img2 && <img src={img2} />}
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
